<!--账号配置Ec-->
<template>
  <div class="account-setting">
    <div class="step">
      <div class="step-title">
        <h6>第一步：配置账号</h6>
        <i class="el-icon-sort" @click="handleChangeSettingStyleClick()"></i>
      </div>
      <el-form label-width="200px" label-position="left" :model="formAccount" ref="formAccount" @keyup.enter.native="submitForm('formAccount')" v-if="formAccount.param10 !== '2'">
        <el-form-item label="ec账号CorpID" prop="param1" :rules="{ required: true, message: '请输入ec账号CorpID', trigger: 'change' }">
          <el-input placeholder="在ec系统/api管理/基础配置中查看" v-model="formAccount.param1"></el-input>
        </el-form-item>
        <el-form-item label="ec账号APPID" prop="param2" :rules="{ required: true, message: '请输入ec账号APPID', trigger: 'change' }">
          <el-input placeholder="在ec系统/api管理/基础配置中查看" v-model="formAccount.param2"></el-input>
        </el-form-item>
        <el-form-item label="ec账号APPSECRET" prop="param3" :rules="{ required: true, message: '请输入ec账号APPSECRET', trigger: 'change' }">
          <el-input placeholder="在ec系统/api管理/基础配置中查看" v-model="formAccount.param3"></el-input>
        </el-form-item>
        <!-- <el-form-item label="同步数据到ec" prop="sync">
          <el-switch v-model="formAccount.sync"></el-switch>
        </el-form-item>
        <p class="tip"><i class="el-icon-warning-outline"></i>资源同步crm只支撑招商智投(智投)模式</p>
        <div class="button">
          <el-button type="primary" size="small" @click="submitForm('formAccount')">保存</el-button>
        </div> -->
      </el-form>
    </div>
    <template v-if="formAccount.param10 !== '2'">
      <div class="step">
        <h6>第二步：信息配置</h6>
        <p class="goSetting">来源配置、字段配置、消息通知配置<span>（若不需要可不填）</span></p>
      </div>
      <div class="step">
        <h6>第三步：配置话务排班</h6>
        <p class="goSetting"><span>*</span>去资源同步crm-ec-话务排班-日期配置，设置推送消息接受人员和规则</p>
      </div>
      <div class="step">
        <h6>第四步：打开同步开关</h6>
        <el-form label-width="200px" label-position="left" :model="formAccount" ref="formAccount" @keyup.enter.native="submitForm('formAccount')">
          <el-form-item label="同步数据到ec" prop="sync">
            <el-switch v-model="formAccount.sync"></el-switch>
          </el-form-item>
          <!-- <p class="tip"><i class="el-icon-warning-outline"></i>资源同步crm只支持招商智投(智投)模式</p> -->
          <div class="button">
            <el-button type="primary" size="small" @click="submitForm('formAccount')">保存</el-button>
          </div>
        </el-form>
      </div>
    </template>
    <template v-else>
      <div>
        <el-form label-width="200px" label-position="left" :model="formAccount" ref="formAccount" @keyup.enter.native="submitForm('formAccount')">
          <el-form-item label="权限类型" prop="param8" :rules="{ required: true, message: '请选择权限类型', trigger: 'change' }">
            <el-select v-model="formAccount.param8" placeholder="请选择">
              <el-option value="1" label="三方推送客户"></el-option>
              <el-option value="2" label="客户&获取来源信息"></el-option>
            </el-select>
            <div class="tip-other" v-show="formAccount.param8 === '2'">注：新增客户&获取来源信息权限，才能将资源的地区推送到ec的地区字段</div>
          </el-form-item>
          <el-form-item label="CorpID" prop="param1" :rules="{ required: true, message: '请输入CorpID', trigger: 'change' }">
            <el-input placeholder="请输入" v-model="formAccount.param1"></el-input>
          </el-form-item>
          <el-form-item label="token" prop="param3" :rules="{ required: true, message: '请输入token', trigger: 'change' }">
            <el-input placeholder="请输入" v-model="formAccount.param3"></el-input>
          </el-form-item>
          <el-form-item label="员工ID" prop="param4" :rules="{ required: true, message: '请输入员工ID', trigger: 'change' }">
            <el-input placeholder="请输入" v-model.trim="formAccount.param4" @blur="handleParam4Blur"></el-input>
          </el-form-item>
          <el-form-item label="跟进员工ID" prop="param5" :rules="{ required: true, message: '请输入跟进员工ID', trigger: 'change' }">
            <el-input placeholder="请输入" v-model="formAccount.param5"></el-input>
          </el-form-item>
          <el-form-item label="推送备注" prop="param6" :rules="{ required: true, message: '请选择推送备注', trigger: 'change' }">
            <el-select v-model="formAccount.param6" placeholder="请选择">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源名称">
            <template v-if="formAccount.param8 === '2'">
              <el-select v-model="formAccount.param9" placeholder="请选择" clearable @change="handleParam9">
                <el-option v-for="item in remote.projectList" :key="item.sourceId" :label="item.sourceName" :value="item.sourceId"></el-option>
              </el-select>
              <el-link :underline="false" :disabled="remote.disabled" type="primary" @click="handleFormAccount()">更新选项</el-link>
            </template>
            <el-input v-else placeholder="请输入" v-model="formAccount.param7"></el-input>
          </el-form-item>
          <el-form-item label="同步数据到ec" prop="sync" :rules="{ required: true, message: '请选择同步数据到ec', trigger: 'change' }">
            <el-switch v-model="formAccount.sync"></el-switch>
          </el-form-item>
          <div class="button">
            <el-button type="primary" size="small" @click="submitForm('formAccount')">保存</el-button>
          </div>
        </el-form>
      </div>
    </template>
  </div>
</template>
<script>
  import {FormArgument} from '@/models/ec-setting'
  import Api from '@/api/client/ec-setting'
  export default {
    data () {
      return {
        formAccount: new FormArgument(),
        remote: {
          disabled: false,
          projectList: []
        }
      }
    },
    created () {
      this.getAccount()
      this.getEcFieldSelect()
    },
    methods: {
      getAccount () {
        const crmCode = {
          crmCode: 'ec'
        }
        Api.getEcAccount(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            // 新增的时候给默认值
            if (body.id === null) {
              body.param6 = '0'
              body.param8 = '1'
              body.sync = true
            }
            this.formAccount = body
          } else {
            this.table.list = []
            this.$message.error(body.error)
          }
        })
      },
      submitForm (formName) {
        this.$confirm('确定保存？若ec账号CorpID变化了，之前的配置数据将被清除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.formAccount.crmCode = 'ec'
          if (this.formAccount.param10 === '2') {
            this.formAccount.param2 = 'X-Ec-Third-Token'
          }
          this.$refs[formName].validate((valid) => {
            if (valid) {
              Api.addEcAccount(this.formAccount, response => {
                let status = response.status || 0
                let body = response.data || []
                if (status === 200 || status === 204) {
                  this.$message.success('保存成功！')
                } else {
                  this.$message.error('保存成功！')
                }
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      handleChangeSettingStyleClick () {
        if (this.formAccount.param10 === '1') {
          this.formAccount.param10 = '2'
        } else {
          this.formAccount.param10 = '1'
        }
      },
      handleParam9 (value) {
        if (value) {
          this.formAccount.channelSourceName = this.remote.projectList.find(item => item.sourceId === value).sourceName
        } else {
          this.formAccount.param9 = ''
          this.formAccount.channelSourceName = ''
        }
      },
      getEcFieldSelect () {
        const crmCode = {
          crmCode: 'ec'
        }
        Api.getEcFieldSelect(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.remote.projectList = (body.list || []).map(item => {
              return {
                sourceId: item.code,
                sourceName: item.name
              }
            })
          }
        })
      },
      handleParam4Blur (e) {
        this.formAccount.param5 = e.target.value
      },
      handleFormAccount () {
        this.remote.disabled = true
        Api.getEcSource(response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.remote.projectList = body.list || []
            this.$message.success('更新成功!')
          } else {
            this.$message.error(body.error)
          }
          this.remote.disabled = false
        })
      }
    }
  }
</script>
<style scoped lang="scss">
.account-setting{
  width: 900px;
  margin-top:15px;
  h6{
    color:#1F2F3D;
    font-size: 22px;
    font-weight: normal;
    line-height: 3;
    margin:0;
  }
  .step-title {
    display: flex;
    justify-content: space-between;
    .el-icon-sort {
      transform: rotate(-90deg);
      font-size: 22px;
      color: gray;
    }
  }
  .goSetting{
    color:#606266;
    font-size: 14px;
    margin:0 0 20px;
    span{
      color:#FF0000;
      padding-right:5px;
    }
  }
  .tip{
    color:#FF4F4F;
    font-size: 12px;
    position: relative;
    top:-10px;
    i{
      margin-right:5px;
      font-size: 14px;
    }
  }
  .tip-other {
    color:#606266;
    font-size: 12px;
    line-height: 2.5em;
  }
  // .el-input{
  //  width:50%;
  // }
  .button{
    text-align: center;
    button{
      width:100px;
      height:30px;
      line-height:1;
      background:rgba(8,94,204,1);
      border-radius:4px;
      padding:0;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/ec/EcAccount.vue